import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { INCLUDED_REPAIR_GROUPS } from '../data/Store'
import { OPTIONAL_REPAIR_GROUPS } from '../data/Store'


const styles = theme => ({
  table: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 6,
  },
  tableRow: {
    height: theme.spacing.unit,
  },
  tableCell: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px !important`,
  },
  para: {
    margin: `${theme.spacing.unit * 3}px 0`,
  },
});




class RepairGroupsForm extends React.Component {

  state = {}


  render = () => {
    const {classes, order, actions} = this.props

    const pairs = []
    for (let i = 0; i < INCLUDED_REPAIR_GROUPS.length; i++) {
      const g = INCLUDED_REPAIR_GROUPS[i];
      if (i % 2 === 1) pairs[pairs.length - 1].push(g)
      else             pairs.push([g])
    }

    return (
      <div>
        <Typography variant="body1" className={classes.para}>
          Your book comes with the following Repair Groups by default.
        </Typography>

        <Table padding="dense" className={classes.table}>
          <TableBody>
            {
              pairs.map((groups, i) => (
                <TableRow key={i} className={classes.tableRow}>
                  <TableCell className={classes.tableCell} align="right">
                    {groups[0].name}
                  </TableCell>
                  {
                    groups[1]
                    ?
                      <TableCell className={classes.tableCell} align="left">
                        {groups[1].name}
                      </TableCell>
                    :
                      null
                  }
                </TableRow>
              ))
            }
          </TableBody>
        </Table>

        <Typography variant="body1" className={classes.para}>
          Please indicate if you would like to include these additional Repair
          Groups in your book.
        </Typography>

        <Grid container>
          {OPTIONAL_REPAIR_GROUPS.map(g => (
            <Grid item key={g.code} xs={12} sm={6} md={3}>
              <FormControlLabel
                label={g.name}
                control={
                  <Checkbox
                    checked={order.isPrintingGroupCode(g.code)}
                    onChange={() => actions.toggleRepairGroup(order, g.code)}
                    value={g.code}
                  />
                }
              />
            </Grid>
          ))}

        </Grid>

      </div>
    )
  }
}

RepairGroupsForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(RepairGroupsForm);
